import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Public paths that don't require authentication
const PUBLIC_PATHS = ['/agreement', '/landing', '/login', '/auth'];

const RequireAuth = ({ children, requiredPermissions = [] }) => {
  const location = useLocation();
  const { isAuthenticated, permissions } = useSelector(state => state.auth);

  // Check if this is a public path that doesn't need auth
  const isPublicPath = PUBLIC_PATHS.some(path => location.pathname.startsWith(path));
  if (isPublicPath) {
    return children;
  }

  // Check if user is authenticated
  if (!isAuthenticated) {
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Check permissions if required
  if (requiredPermissions.length > 0) {
    const hasPermission = requiredPermissions.some(perm => 
      permissions.includes(perm)
    );
    
    if (!hasPermission) {
      // Redirect to dashboard or unauthorized page
      return <Navigate to="/" replace />;
    }
  }
  
  // Render children if authenticated and authorized
  return children;
};

// Add named export
export { RequireAuth };

// Keep default export
export default RequireAuth; 